/**
 * Whether idle chrome should show the pairing QR shell.
 *
 * - Explicit unregister pending always shows QR (tenant may clear async).
 * - Otherwise a painted tenant wins over sticky `registrationCode` so a
 *   registered player never stays on QR while Org is already set (#1438).
 */
export function shouldShowUnregisteredIdle(input: {
  tenant: unknown | null
  registrationCode: string | null
  pairingAfterUnregisterPending: boolean
}): boolean {
  if (input.pairingAfterUnregisterPending) {
    return true
  }
  if (input.tenant != null) {
    return false
  }
  return typeof input.registrationCode === 'string'
}
